import React, { useEffect, useRef, useState } from "react";
import { DiagramEngine } from "@projectstorm/react-diagrams";

import EditorController from "..";
import LineSegment from "./LineSegment";
import LinkModel from "./Model";

export interface LinkWidgetProps {
  link: LinkModel;
  diagramEngine: DiagramEngine;
}

const LinkWidget: React.FC<LinkWidgetProps> = ({ link, diagramEngine }) => {
  const [selected, setSelected] = useState(false);
  const ref = useRef<SVGPathElement>(null);
  const isHidden = link.getOptions().extras.isHidden;

  useEffect(() => {
    link.setRenderedPaths(ref.current ? [ref.current] : []);
    return () => link.setRenderedPaths([]);
  });

  if (isHidden) return null;

  return (
    <g>
      <LineSegment
        key="link-0"
        path={link.getSVGPath()}
        selected={selected}
        diagramEngine={diagramEngine as EditorController}
        factory={diagramEngine.getFactoryForLink(link)}
        onSelection={setSelected}
        link={link}
        forwardRef={ref}
      />
    </g>
  );
};

export default LinkWidget;
